import type {VersionInfo} from './app/utils.class';

export const compiledVersion: VersionInfo = {"buildNumber":"D. van der Steen B.V_acceptance_2026-11-04_15-0-22","buildId":"24904","environment":"trackline-acceptance","datetime":"2026-11-04T14:07:43.291Z","checkForUpdates":true}